import { c as _c } from "react/compiler-runtime";
import { ProposalFeedCardSkeleton } from './proposal-feed-card-skeleton';
export function ProposalFeedRowMobileSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ProposalFeedCardSkeleton variant="mobile" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}